import { ResponsiveContainer, Tooltip, Legend } from "recharts";

import HNSColors from "../../../ui library/HNSColors";
import StandardBarChart from "../chart_renderers/BarRenderer";
import StandardLineChart from "../chart_renderers/LineRenderer";
import StandardPieChart from "../chart_renderers/PieRenderer";

export default function GenericChartCard({ record }) {
  const chart = record?.raw || {};
  const meta = chart?.meta || {};
  const chartType = meta?.chart_type;
  const CHARTS = {
    "line-chart": StandardLineChart,
    "pie-chart": StandardPieChart,
    "bar-chart": StandardBarChart,
  };
  const CHART = CHARTS[chartType];
  if (!CHART) {
    return null;
  }
  return (
    <div style={{ position: "relative", height: 350 }}>
      <ResponsiveContainer>
        <CHART chart={chart}>
          <Tooltip
            contentStyle={{
              borderRadius: "12px",
              background: `linear-gradient(91.64deg, ${HNSColors.primary[300]} -2.29%, ${HNSColors.primary[400]} 24.1%, ${HNSColors.primary[500]} 46.74%, ${HNSColors.tertiary[500]} 89.2%, ${HNSColors.tertiary[600]} 102.56%)`,
              color: HNSColors.neutrals[900],
              boxShadow: "0 8px 20px rgba(7, 47, 131, 0.35)",
            }}
            itemStyle={{
              color: HNSColors.neutrals[900],
            }}
          />
          <Legend height="10%" />
        </CHART>
      </ResponsiveContainer>
    </div>
  );
}
